export function displayStats(showNote:boolean, totalPoints:number, totalPossible:number, submissionDate){
    
    let html = '';
    if (showNote){
        html = displayDetailedStats(totalPoints, totalPossible, submissionDate);
    } else {
        html = displayOverview(submissionDate);
    }
    $("#ab-form").prepend(html)
}

function displayDetailedStats(totalPoints:number, totalPossible:number, submissionDate){
    const correctPercentage = roundToTwo(totalPoints / totalPossible) * 100
    const html = '<div class="form-wrapper">' +
    '<h3>Auswertung</h3>' + 
    '<p></p>' + 
    '<p>Diese Abgabe war am <b>' + submissionDate + '</b></p>' + 
    '<p>Punkte: <b>' + totalPoints + '</b> von <b>' + totalPossible + '</b> Punkten (' + roundToTwo(correctPercentage) + '%)' + 
    '</div>';
    return html;
}

export function roundToTwo(num:number) {    
    return +(Math.round(num + "e+2")  + "e-2");
}

function displayOverview(submissionDate){
    const html = '<div class="form-wrapper">' + 
    '<h3>Auswertung</h3>' + 
    '<p></p>' + 
    '<p> Diese Abgabe war am <b>' + submissionDate + '</b>' +
    '</div>';
    return html;
}